import React from "react";
import ProductCard from "../Card/ProductCard";
import "./Layout.css";

const Layout = ({ products }) => {
  return (
    <div className="layoutcontainer">
      <div className="container-fluid">
        <div className="row">

          {/* LEFT COLUMN */}
          <div className="col-lg-6 col-md-6 col-sm-12">
            <div className="row">

              {products.map((product, index) => {
                const pos = index % 6;

                // LEFT COLUMN POSITIONS → 0(big), 4, 5
                if (pos === 0) {
                  return (
                    <div className="col-12 ps-0 pe-1 pb-1" key={index}>
                      <ProductCard
                        namefontsize="t5"
                        categoryfontsize="t7"
                        product={product}
                      />
                    </div>
                  );
                }

                if (pos === 4 || pos === 5) {
                  return (
                    <div className="col-6 ps-0 pe-1 pb-1" key={index}>
                      <ProductCard product={product} />
                    </div>
                  );
                }

                return null;
              })}

            </div>
          </div>

          {/* RIGHT COLUMN */}
          <div className="col-lg-6 col-md-6 col-sm-12">
            <div className="row">

              {products.map((product, index) => {
                const pos = index % 6;

                // RIGHT COLUMN POSITIONS → 1, 2, 3(big)
                if (pos === 1 || pos === 2) {
                  return (
                    <div className="col-6 ps-0 pe-1 pb-1" key={index}>
                      <ProductCard product={product} />
                    </div>
                  );
                }

                if (pos === 3) {
                  return (
                    <div className="col-12 ps-0 pe-1 pb-1" key={index}>
                      <ProductCard
                        namefontsize="t5"
                        categoryfontsize="t7"
                        product={product}
                      />
                    </div>
                  );
                }

                return null;
              })}

            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Layout;
